/* snz-welcome-polish.js - moved out of sections/snz-welcome-polish.liquid on 9 Oct 2026 (SNZ-POPUP-ASSETS) so browsers cache it instead of re-reading it inside every page. */
(function () {
var C = (function () { try { return JSON.parse(document.getElementById("snz-welcome-polish-cfg").textContent); } catch (e) { return {}; } })();
  (function () {
    if (window.__snzWelcomePolish) return;
    window.__snzWelcomePolish = true;
    var SUB = C["SUB"];
    var PH = C["PH"];
    var OK = C["OK"];
    var QUIET_PAGE = C["QUIET_PAGE"];
    var MIN = C["MIN"];
    var USE_BAR = C["USE_BAR"];
    var LEFT = C["LEFT"] === 'left';

    var KEY_HIDE = 'snz_welcome_hide_until';
    var KEY_DONE = 'snz_welcome_done';
    var KEY_TAB = 'snz_welcome_tab_hide_until';
    var KEY_TIP = 'snz_gift_tip_seen';
    var SKIP = ['cart', 'checkout', 'challenge', 'account', 'tools', 'apps', 'password', 'orders'];
    var TICK = '<svg class="snz-wg__tick" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M2.5 8.5 6.2 12 13.5 4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    function ls(k, v) {
      try {
        if (v === undefined) return window.localStorage.getItem(k);
        window.localStorage.setItem(k, v);
      } catch (e) {}
      return null;
    }
    function ss(k, v) {
      try {
        if (v === undefined) return window.sessionStorage.getItem(k);
        window.sessionStorage.setItem(k, v);
      } catch (e) {}
      return null;
    }
    function active(k) { var t = parseInt(ls(k), 10); return !!(t && Date.now() < t); }
    function isDone() { return ls(KEY_DONE) === '1'; }

    var q = window.location.search;
    var forced = q.indexOf('snz_pop=1') > -1;
    var blocked = q.indexOf('snz_pop=0') > -1;
    var AD = /[?&](gclid|gbraid|wbraid|gad_source|gad_campaignid|dclid|fbclid|ttclid|msclkid|li_fat_id|epik|b)=/i.test(q) ||
      /[?&]utm_medium=(cpc|ppc|paid|display|paidsocial|paid_social|social_paid|shopping)/i.test(q);
    // 13 Oct 2026 (SNZ-POPUP-AD-SESSION): the click id is gone from the URL on the next page, so
    // remember the ad visit for the session; no automatic popup anywhere on the visit.
    if (AD) ss('snz_ad_visit', '1'); else if (ss('snz_ad_visit') === '1') AD = true;
    var mq = window.matchMedia ? window.matchMedia('(max-width:799px)') : { matches: false };
    var MOBILE = mq.matches;
    var skipped = (function () {
      var parts = window.location.pathname.split('/');
      for (var i = 0; i < parts.length; i++) if (SKIP.indexOf(parts[i]) > -1) return true;
      return false;
    })();

    var pop = document.querySelector('[data-snz-welcome]');
    var tab = document.querySelector('[data-snz-wtab]');
    var bar = document.querySelector('[data-snz-wbar]');
    var tip = tab ? tab.querySelector('[data-snz-wg-tip]') : null;
    var design = !!(window.Shopify && window.Shopify.designMode);
    var CODE = pop ? (pop.getAttribute('data-code') || '').toUpperCase() : '';

    // No automatic full-screen popup on mobile, product pages, the builder or ad landings.
    var quiet = !forced && (QUIET_PAGE || AD || MOBILE);
    var delay = 8, scrollTrig = false, days = 30;
    var mobileOff = false;
    if (pop) {
      delay = parseInt(pop.getAttribute('data-delay'), 10);
      if (!(delay >= 0)) delay = 8;
      scrollTrig = pop.getAttribute('data-scroll') === '1';
      days = parseInt(pop.getAttribute('data-days'), 10);
      if (!(days > 0)) days = 30;
      mobileOff = MOBILE && pop.getAttribute('data-mobile') !== '1';
      if (quiet && !design) {
        pop.setAttribute('data-delay', '2000000');
        pop.setAttribute('data-scroll', '0');
        pop.setAttribute('data-exit', '0');
      }
    }

    function openPop(fromGift) {
      if (!pop || !pop.hidden) return;
      var src = fromGift && tab && !reduced ? (tab.querySelector('.snz-wg__open') || tab).getBoundingClientRect() : null;
      var done = isDone();
      var panes = pop.querySelectorAll('[data-snz-welcome-pane]');
      for (var i = 0; i < panes.length; i++) {
        panes[i].hidden = panes[i].getAttribute('data-snz-welcome-pane') !== (done ? 'done' : 'form');
      }
      pop.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var card = pop.querySelector('.snz-welcome__card');
      // Grow the card out of the gift: origin = the gift's centre in card coordinates.
      if (card && src && src.width) {
        var cr = card.getBoundingClientRect();
        card.style.setProperty('--snz-ox', Math.round(src.left + src.width / 2 - cr.left) + 'px');
        card.style.setProperty('--snz-oy', Math.round(src.top + src.height / 2 - cr.top) + 'px');
        pop.classList.add('snz-from-gift');
        setTimeout(function () { pop.classList.remove('snz-from-gift'); }, 600);
      }
      if (card) { try { card.focus({ preventScroll: true }); } catch (err) { card.focus(); } }
    }

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;

    // Lid swings open, glow and glints, and the card grows out of the gift.
    function unwrap() {
      if (!tab || tab.classList.contains('is-opening')) return;
      ls(KEY_TIP, '1');
      if (isDone() || reduced) { openPop(); return; }
      tab.classList.add('is-opening');
      setTimeout(function () {
        openPop(true);
        setTimeout(function () { tab.classList.remove('is-opening'); }, 500);
      }, 220);
    }

    // The reveal after signup: pane lines settle in order, light passes over
    // the code, a few glints rise from it.
    function celebrate() {
      if (!pop) return;
      pop.classList.add('snz-revealing');
      setTimeout(function () { pop.classList.remove('snz-revealing'); }, 1600);
      if (reduced) return;
      var card = pop.querySelector('.snz-welcome__card');
      var code = pop.querySelector('.snz-welcome__codewrap');
      if (!card || !code) return;
      var cr = card.getBoundingClientRect(), r = code.getBoundingClientRect();
      var g = document.createElement('span');
      g.className = 'snz-wg-glints';
      g.setAttribute('aria-hidden', 'true');
      g.innerHTML = new Array(7).join('<i></i>');
      g.style.left = Math.round(r.left + r.width / 2 - cr.left) + 'px';
      g.style.top = Math.round(r.top + r.height / 2 - cr.top) + 'px';
      card.appendChild(g);
      setTimeout(function () { g.classList.add('is-go'); }, 220);
      setTimeout(function () { if (g.parentNode) g.parentNode.removeChild(g); }, 1200);
    }

    // Lift the box / banner above whatever fixed bar owns the bottom edge.
    function place() {
      if (!tab || !bar) return;
      var h = window.innerHeight, off = 0;
      var xs = LEFT ? [4, 40] : [window.innerWidth - 4, window.innerWidth - 40];
      // Probe upwards: bars can stack (the builder's sheet handle sits on its price bar).
      for (var pass = 0; pass < 5 && document.elementsFromPoint; pass++) {
        var top = h - off;
        for (var xi = 0; xi < xs.length; xi++) {
          var els = document.elementsFromPoint(xs[xi], h - off - 4);
          for (var i = 0; i < els.length; i++) {
            var n = els[i];
            if (n === document.documentElement || n === document.body) continue;
            if (tab.contains(n) || bar.contains(n) || (pop && pop.contains(n))) continue;
            for (var a = n; a && a !== document.body; a = a.parentElement) {
              if (window.getComputedStyle(a).position === 'fixed') {
                var r = a.getBoundingClientRect();
                if (r.top > h * 0.45 && r.top < top) top = r.top;
                break;
              }
            }
          }
        }
        if (Math.round(h - top) <= off) break;
        off = Math.round(h - top);
      }
      var b = off + 'px';
      if (tab.style.bottom !== b) tab.style.bottom = b;
      if (bar.style.bottom !== b) bar.style.bottom = b;
      tab.classList.toggle('is-lifted', off > 0);
      bar.classList.toggle('is-lifted', off > 0);
    }
    function visible() { return (tab && !tab.hidden) || (bar && !bar.hidden); }
    var tmr = null;
    function schedule() {
      if (tmr) return;
      tmr = setTimeout(function () { tmr = null; if (visible()) place(); }, 150);
    }

    function show(el) {
      if (!el || !el.hidden) return;
      el.hidden = false;
      place();
      setTimeout(function () { el.classList.add('is-in'); }, 30);
    }
    function hide(el) {
      if (!el || el.hidden) return;
      el.classList.remove('is-in');
      el.hidden = true;
    }

    // The label beside the box: shown until the first open; on phones it tucks
    // away after a few seconds so it never sits over content.
    var tipTimer = null;
    function tipIn() {
      if (!tip || tab.classList.contains('snz-wg--done')) return;
      if (ls(KEY_TIP) === '1' && !forced) { tip.classList.add('is-gone'); tip.tabIndex = -1; return; }
      tip.classList.remove('is-gone');
      tip.removeAttribute('tabindex');
      if (MOBILE) {
        clearTimeout(tipTimer);
        tipTimer = setTimeout(function () { tip.classList.add('is-gone'); tip.tabIndex = -1; }, 7000);
      }
    }

    function canTab() { return !!pop && !skipped && !blocked && !mobileOff && !isDone() && !active(KEY_TAB); }
    function minimise() {
      hide(bar);
      if (isDone()) { showDone(); return; }
      if (canTab()) { show(tab); tipIn(); }
    }
    function rememberClose() { ls(KEY_HIDE, String(Date.now() + days * 86400000)); }

    // ---- After signup: the status pill, driven by the live cart ----
    function setPill(state) {
      if (!tip) return;
      // 20 Oct 2026, audit #27: no configured code means there is no discount to show -
      // render nothing (no pill text, no aria-label) rather than a false "10% off".
      if (!CODE) {
        if (tip.innerHTML) tip.innerHTML = '';
        tip.removeAttribute('aria-label');
        tip.removeAttribute('data-state');
        return;
      }
      if (tip.getAttribute('data-state') === state) return;
      tip.setAttribute('data-state', state);
      if (state === 'applied') {
        tip.innerHTML = TICK + '<span><b>10%</b> applied</span>';
        tip.setAttribute('aria-label', '10% welcome discount applied to your bag');
      } else if (state === 'saved') {
        tip.innerHTML = '<span><b>10%</b> saved</span><span class="snz-wg__sub">· to your bag</span>';
        tip.setAttribute('aria-label', '10% welcome discount saved to your bag. It comes off at checkout');
      } else {
        tip.innerHTML = '<span><b>10%</b> off</span><span class="snz-wg__sub">· apply</span>';
        tip.setAttribute('aria-label', 'Apply your 10% welcome discount to your bag');
      }
      ss('snz_gift_state', state);
    }
    var refreshing = false;
    function refreshPill() {
      if (!tab || !tab.classList.contains('snz-wg--done') || refreshing) return;
      refreshing = true;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var state = 'none';
          var list = (cart && cart.discount_codes) || [];
          for (var i = 0; i < list.length; i++) {
            if (String(list[i].code).toUpperCase() === CODE) state = list[i].applicable ? 'applied' : 'saved';
          }
          setPill(state);
        })
        .catch(function () {})
        .then(function () { refreshing = false; });
    }
    function showDone() {
      if (!tab || !pop || skipped || blocked || mobileOff || design) return;
      if (!CODE) { setPill('none'); return; } // 20 Oct 2026, audit #27: no code, no pill
      tab.classList.add('snz-wg--done');
      if (tip) { tip.classList.remove('is-gone'); tip.removeAttribute('tabindex'); }
      setPill(ss('snz_gift_state') || 'none');
      show(tab);
      refreshPill();
    }

    function wire() {
      if (!pop || !tab || !bar) return;

      tab.addEventListener('click', function (e) {
        var t = e.target && e.target.closest ? e.target : null;
        if (!t) return;
        if (t.closest('[data-snz-wtab-close]')) {
          ls(KEY_TAB, String(Date.now() + days * 86400000));
          hide(tab);
          return;
        }
        if (t.closest('[data-snz-wtab-open]')) {
          if (tab.classList.contains('snz-wg--done')) openPop();
          else unwrap();
        }
      });

      bar.addEventListener('click', function (e) {
        var t = e.target && e.target.closest ? e.target : null;
        if (!t) return;
        if (t.closest('[data-snz-wbar-close]')) { rememberClose(); minimise(); return; }
        if (t.closest('[data-snz-wbar-open]')) { hide(bar); openPop(); }
      });

      // Popup closed (x, "Not today", Escape, scrim) -> back to the box, or the pill once claimed.
      if (window.MutationObserver) {
        new MutationObserver(function () {
          if (pop.hidden) minimise();
          else { hide(tab); hide(bar); }
        }).observe(pop, { attributes: true, attributeFilter: ['hidden'] });
      }

      // Keep the pill honest as the bag changes.
      document.addEventListener('snz:welcome-applied', function () { setTimeout(refreshPill, 50); });
      if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
        try { window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refreshPill, 300); }); } catch (e) {}
      } else {
        window.addEventListener('load', function () {
          if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
            try { window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refreshPill, 300); }); } catch (e) {}
          }
        });
      }
      document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') refreshPill(); });
      window.addEventListener('pageshow', function (e) { if (e.persisted) refreshPill(); });

      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      setInterval(function () { if (visible()) place(); }, 1000);

      if (design || skipped || blocked) return;

      // Just came back from signing up: the popup opened itself on the code pane.
      if (!pop.hidden) {
        var donePane = pop.querySelector('[data-snz-welcome-pane="done"]');
        if (donePane && !donePane.hidden) celebrate();
        return;
      }

      if (isDone()) { setTimeout(showDone, 600); return; }
      if (forced || mobileOff) return;

      // Closed before: sit minimised straight away.
      if (active(KEY_HIDE)) { setTimeout(minimise, 1200); return; }

      // Desktop, ordinary page: the popup opens itself as before; the box follows its close.
      if (!quiet) return;

      var fired = false;
      var useBar = USE_BAR && MOBILE && !QUIET_PAGE && !AD;
      function go() {
        if (fired || !pop.hidden) return;
        fired = true;
        window.removeEventListener('scroll', onScroll);
        if (useBar) show(bar); else minimise();
      }
      function onScroll() {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        if (h > 0 && window.scrollY / h > 0.35) go();
      }
      setTimeout(go, (useBar ? delay : Math.min(delay, 6)) * 1000);
      if (scrollTrig && useBar) window.addEventListener('scroll', onScroll, { passive: true });
    }

    function init() {
      var box = document.querySelector('.footer-block__newsletter');
      if (box) {
        var h = box.querySelector('.footer-block__heading');
        if (SUB && h && !box.querySelector('.footer-block__newsletter-sub')) {
          var p = document.createElement('p');
          p.className = 'footer-block__newsletter-sub';
          p.textContent = SUB;
          h.insertAdjacentElement('afterend', p);
        }
        var input = box.querySelector('input[type="email"]');
        var label = input ? box.querySelector('label[for="' + input.id + '"]') : null;
        if (PH && input) input.setAttribute('placeholder', PH);
        if (PH && label) label.textContent = PH;
        var tags = box.querySelector('input[name="contact[tags]"]');
        if (tags && tags.value.indexOf('welcome-offer') < 0) tags.value += ',welcome-offer';
        var ok = document.getElementById('ContactFooter-success');
        if (OK && ok) {
          var icon = ok.querySelector('.svg-wrapper');
          ok.textContent = '';
          if (icon) ok.appendChild(icon);
          ok.appendChild(document.createTextNode(OK));
        }
      }

      document.addEventListener('click', function (e) {
        var a = e.target && e.target.closest ? e.target.closest('a[href*="snz_pop=1"]') : null;
        if (!a || !pop || !pop.hidden) return;
        e.preventDefault();
        openPop();
      });

      wire();
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();
})();
